import _ from 'lodash';
import { SECTION, SECTION_COLUMN } from "constants/widgetTypes";

const generateData = (columns) => {
  return {
    name: "Section",
    type: SECTION,
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "50%, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": "400px"
        },
        "stretched": true,
        "margin": 0,
        "padding": 0,
        "columnSpacing": 0,
        "background": {
          "type": "color",
          "color": {
            "type": "solid",
            "r": 242,
            "g": 242,
            "b": 242,
            "a": 1
          },
          "media": null,
          "opacity": 0,
          "scale": null,
          "position": null
        },
        "shadow": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": "0",
            "y": "0",
            "b": "0"
          },
          "show": false
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": "100%",
          "height": "auto"
        },
        "stretched": false,
        "margin": 0,
        "padding": 0,
        "columnSpacing": 0,
        "background": null,
        "shadow": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": "0",
            "y": "0",
            "b": "0"
          },
          "show": false
        }
      }
    },
    widgets: _.times(columns).map((index) => {
      return {
        type: SECTION_COLUMN,
        name: "Column",
        properties: {
          "desktop": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px"
              },
              "width": `${100 / columns}%`,
              "height": null
            },
            "container": {
              "minWidth": 1200 / columns,
              "alignment": "center"
            },
            "alignment": "center",
            "background": null
          },
          "mobile": {
            "visible": true,
            "layout": {
              "transform": {
                "translate": "0px, 0px"
              },
              "width": "100%",
              "height": "200px"
            },
            "container": {
              "minWidth": 375,
              "alignment": null
            },
            "alignment": "center",
            "background": null
          }
        }
      }
    })
  };
}

export const sections = [{
  id: 'strip_widget_one',
  name: 'One Column',
  render: () => {
    return <p>One Column</p>
  },
  data: generateData(1)
},
{
  id: 'strip_widget_two',
  name: 'Two Columns',
  render: () => {
    return <p>Two Columns</p>
  },
  data: generateData(2)
},
{
  id: 'strip_widget_three',
  name: 'Three Columns',
  render: () => {
    return <p>Three Columns</p>
  },
  data: generateData(3)
}];